const SelectStyles = {
  control: (base, state) => ({
    ...base,
    border: 0,
    // This line disable the blue border
    // boxShadow: state.isFocused ? "0px 0px 10px -1px var(--primary50)" : 0,
    borderRadius: 0,
  }),
  options: (base, state) => ({
    ...base,
  }),
  input: (styles) => ({ ...styles, border: 0 }),
  placeholder: (styles) => ({ ...styles }),
  singleValue: (styles, { data }) => ({ ...styles }),
};

export default SelectStyles;
